var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMelody2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.sharpcorners_een{fill:#fff;}\r\n\t.st0{fill:#fff;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sharpcorners_een",
    d: "M29,22c0,2-1.586,4.425-4.305,4.905c-2.719,0.479-5.235-0.895-5.619-3.071 c-0.384-2.176,1.51-4.328,4.229-4.807c1.364-0.241,2.676-0.014,3.695,0.546V8.465l-15,3.579c0,0,0,10.956,0,12.956 s-1.586,4.425-4.305,4.905c-2.719,0.479-5.235-0.895-5.619-3.071c-0.384-2.176,1.51-4.328,4.229-4.807 C7.67,21.786,8.982,22.012,10,22.572V6.421L29,2C29,2,29,20,29,22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelody2);
export default __webpack_public_path__ + "static/media/melody2.b659042c39c4ad0f340aaaacde82ad5e.svg";
export { ForwardRef as ReactComponent };